/* © CNES */
import { AxiosResponse } from 'axios';
import { NavigateFunction } from 'react-router-dom';

/**
 * Handle Http Errors from fetch requests.
 * @param res the response of Promises that fetched.
 * @param navigate Function to navigate to maintenance Page if error has status 5**.
 * @param setError400 Function to set Error Page if error has status 4**.
 */
export const handleHttpError = (
  res: Response | AxiosResponse<any, any>,
  navigate: NavigateFunction,
  setError400: Function
) => {
  if (res.status >= 500 && res.status < 600) {
    navigate('/maintenance');
  }

  if (
    res.status >= 400 &&
    res.status < 500 &&
    res.status !== 429 &&
    res.status !== 409
  ) {
    setError400(true);
  }

  if (res.status >= 300 && res.status < 200) {
    throw new Error(`${res.status.toString()} ${res.statusText}`);
  }

  if (res.status === 429) {
    navigate('/ratelimiting');
  }
};

/**
 * Handle Http Error 409 from fetch requests.
 * @param res the response of Promises that fetched.
 */
export const handleHttpError409 = (
  res: Response | AxiosResponse<any, any>,
  setError409: Function
) => {
  if (res.status === 409) {
    setError409(true);
  }
};
